import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'app/_utils/auth/auth.service';
@Injectable({
  providedIn: 'root'
})
export class GrantsByClientsService {

  private urlService = environment.endpointMenu;

  constructor(private http: HttpClient, private readonly cs: CookieService) { }

  async getMenu(client: number) {

    if (client === -1 ) {
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders().set(
        'Content-Type', 'application/json').set('Access-Control-Allow-Origin', '*')
    };

    const at = await AuthService.getAt();
    const wpsid = this.cs.get('wpsid');

    let list = null;
    await this.http.post(this.urlService, { wpsid, at, client }, httpOptions)
      .toPromise()
      .then((data: any) => {
        const {res} = data;
        list = res;
      }).catch(err => console.log);

    return list ? list : [];
  }
}

